import React, { lazy } from 'react';
export function Origin() {
  return <section className="bg-mist py-[58px] md:py-[76px]" data-id="element-67">
      <div className="max-w-page mx-auto px-6 grid grid-cols-1 md:grid-cols-[1fr_0.82fr] gap-10 md:gap-[60px] items-center" data-id="element-68">
        <div data-id="element-69">
          <h2 className="font-display font-medium text-[clamp(1.8rem,3.2vw,2.4rem)] leading-[1.12] tracking-[-0.01em] m-0 mb-[22px]" data-id="element-70">
            Where Chime came from
          </h2>
          <p className="text-ink-60 m-0 mb-[1.1em] text-[1.05rem]" data-id="element-71">
            Chime started with a borrowed trick. One of the oldest, least
            glamorous things a therapist can hand an anxious person is a
            drinking straw: breathe out through the narrow opening and your
            exhale stretches long — and a long, slow exhale is one of the few
            fast, drug-free ways to settle the body. It works. The only problem
            is that a soggy plastic straw is not something you'll keep around
            your neck.
          </p>
          <p className="text-ink-60 m-0 text-[1.05rem]" data-id="element-72">
            So we built the version you would.{' '}
            <strong className="text-ink font-semibold" data-id="element-73">
              Chime is a calibrated internal airway
            </strong>{' '}
            — set to just enough resistance to pace your exhale to about eight
            seconds — inside a pendant quiet and plain enough to wear every day.
            That calibration, not the steel, is the part that does the work.
            It's also the one thing the cheap $9 lookalikes leave out, which is
            why they feel like breathing through an empty tube.
          </p>
        </div>

        <figure className="relative aspect-[4/5] rounded-[24px] border border-[rgba(26,31,43,0.08)] shadow-[0_30px_60px_-34px_rgba(26,31,43,0.4)] overflow-hidden m-0" data-id="element-74">
          <img src="https://cdn.magicpatterns.com/uploads/ibgt8zfQ3nauE4C2xndS65/image_1781586371431_zzmuyk.jpg" alt="The Chime pendant — a slim brushed-steel breathing tube on a fine chain, resting against a smooth stone by the sea at dusk." className="absolute inset-0 w-full h-full object-cover" loading="lazy" data-id="element-75" />
        </figure>
      </div>
    </section>;
}